module.exports = __webpack_public_path__ + "img/channel_background-300w.305543ad.png";